import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SupportFaq } from '../models/supportFaqs.interface';
import { SupportService } from '../services/support.service';
import { FaqEditComponent } from '../faq-edit/faq-edit.component';
import { finalize } from 'rxjs/operators';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CdkDragDrop, moveItemInArray, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss']
})

export class FaqListComponent extends AbstractBiditComponent implements OnInit {
  
  faqs: SupportFaq[];
  locale: string = 'en';

  dataSource = new MatTableDataSource<SupportFaq>();

  displayedColumns: string[] =
    ['supportFaq_Title', 'supportFaq_Content', 'supportFaq_Hyperlink', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(deviceDetectorService: DeviceDetectorService,
    private supportService: SupportService, public dialog: MatDialog) {
    super(deviceDetectorService);
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;
    this.loadFaqs();
  }

  loadFaqs() {
    this.supportService.getFaqList(this.locale)
      .subscribe({
        next: (data) => {
          this.faqs = data;
          this.dataSource.data = this.faqs;       

        },
        error: (error: string) => this.onError(error)
      });
  }  

  showEdit(supportFaqId) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: supportFaqId };
    dialogConfig.width = '1100px';
    dialogConfig.maxHeight = '950px';

    const faqDialogRef = this.dialog.open(FaqEditComponent, dialogConfig);

    faqDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.loadFaqs();
    });
  }

  deleteFaq(supportFaqId) {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.supportService.deleteFaq(supportFaqId)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
              this.loadFaqs();;
            }
          },
          error: (error: string) => this.errors = error
        });
  }

  drop(event: CdkDragDrop<MatTableDataSource<SupportFaq>>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(event.container.data.data, event.previousIndex, event.currentIndex);

      this.supportService.resequenceSupportFaqs(event.container.data.data).subscribe({
        next: (data) => {
          this.loadFaqs();
        },
        error: (err) => this.onError(err)
      });
    }
  }

}
